import { Download } from "lucide-react";
import { useInstallPrompt } from "@/lib/pwa";

export const InstallButton = ({ className = "", compact = false, testid = "install-app-btn" }) => {
  const { canInstall, install } = useInstallPrompt();
  if (!canInstall) return null;
  return (
    <button type="button" onClick={install} data-testid={testid} title="Install Whitestone Portal on this device"
      className={`inline-flex items-center justify-center gap-2 rounded-sm border border-slate-900 bg-slate-900 text-white transition-colors hover:bg-[#E63946] hover:border-[#E63946] ${compact ? "px-3 py-1.5 text-xs" : "h-10 w-full px-4 text-sm font-medium"} ${className}`}>
      <Download size={compact ? 13 : 15} /> Install Whitestone Portal
    </button>
  );
};
